module.exports = __webpack_public_path__ + "static/img/jzrgl_morenka_01.ec657eaf.png";